import resourceService from './resource_service';

const modelName = 'plant-user';

const attributes = {
  name: '',
  code: '',
  rfid: '',
  level: '',
};

const relationships = {
  site: {
    jsonApi: 'hasOne',
  },
};

export default resourceService(modelName, attributes, relationships);
